import React, { useState, useEffect } from "react";
import Head from "next/head";
import { useRouter } from "next/router";
import LeftSidebar from "@/components/Layouts/LeftSidebar";
import TopNavbar from "@/components/Layouts/TopNavbar";
import ScrollToTop from "./ScrollToTop";
import ControlPanelModal from "./ControlPanelModal";

import { getUserData } from "@/utils/userData";
import dynamic from 'next/dynamic';

const MobileNavbar = dynamic(() => import('@/components/MobileNavbar'), { 
    ssr: false 
});

export default function Layout({children, isDarkMode}) {

	const router = useRouter();

	const [active, setActive] = useState(false);

	const toogleActive = () => {
		setActive(!active);
	};

     const { userData } = getUserData(); 

     const [isPWA, setIsPWA] = useState(false);

     useEffect(() => {
		const checkPWA = () => {
			const isStandalone = () =>
               window.matchMedia('(display-mode: standalone)').matches ||
               window.navigator.standalone === true ||
               (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1 &&
               !navigator.userAgent.includes('Safari'));

			setIsPWA(isStandalone());
		};

		checkPWA();
	}, []);

	return (
		<>
			<Head>
				<title>
					All Consulting Lascu
				</title>

			</Head>

			<div className={`main-wrapper-content ${active && "active"}`}>
				{!(
					router.pathname === "/autentificare" ||
					router.pathname === "/inregistrare" ||
					router.pathname ===
						"/authentication/forgot-password" ||
					router.pathname === "/authentication/lock-screen" ||
					router.pathname === "/authentication/confirm-mail" ||
					router.pathname === "/authentication/logout"
				) && (
					<>
						<TopNavbar toogleActive={toogleActive} isDarkMode={isDarkMode}/>

						<LeftSidebar toogleActive={toogleActive} />
					</>
				)}

				<div className='main-content'>
					{children}

					{isPWA && !(
						router.pathname === "/autentificare" ||
                              router.pathname === "/inregistrare" ||
                              router.pathname ===
                                   "/authentication/forgot-password" ||
                              router.pathname === "/authentication/lock-screen" ||
                              router.pathname === "/authentication/confirm-mail" ||
                              router.pathname === "/authentication/logout"
					) && (

                         <MobileNavbar isDarkMode={isDarkMode}/>

                         )}
				</div>
			</div>

			{/* ScrollToTop */}
			<ScrollToTop />

               {userData && userData.admin > 0 && (
                    !(
                         router.pathname === "/autentificare" ||
                         router.pathname === "/inregistrare" ||
                         router.pathname ===
                              "/authentication/forgot-password" ||
                         router.pathname === "/authentication/lock-screen" ||
                         router.pathname === "/authentication/confirm-mail" ||
                         router.pathname === "/authentication/logout"
                    ) && <ControlPanelModal />
                )}   
		</>
	);
};

